<template>
  <div>
    <header class="modal-header">
      We will work with your provider to make sure this issue doesn’t continue
    </header>
    <section class="modal-body"></section>
    <footer class="modal-footer">
      <LsButton text="ok" track-id="return_request_success-ok" @click="close" />
    </footer>
  </div>
</template>

<script>
import { LsButton } from '@/components/common';

export default {
  name: 'ReturnRequestSuccess',
  components: {
    LsButton,
  },
  methods: {
    close() {
      this.$parent.close();
    },
  },
};
</script>

<style lang="scss" scoped></style>
